<template>
  <div class="o-tile-list">
    <div class="h-section h-section--margin-base h-remove-child-margin">
      <div v-if="hasItems" class="h-grid h-grid--row-gutter h-remove-child-padding-top">
        <div v-for="business in paginatedBusinesses" :key="business.id" class="h-grid__col h-grid__col--xs-6 h-grid__col--md-4">
          <tile :color="getColor(business)" :url="business.url" :image="getImage(business)" :title="business.name" :description="business.entreprise_short_description" :city="business.city">
            <template v-slot:badges v-if="getBusinessBadges(business).length > 0">
              <ul class="m-tile__badge">
                <li class="m-tile__badge-item" v-for="badge in getBusinessBadges(business)" :key="badge.UmbracoId">
                  <img class="m-tile__badge-img" :src="`${badge.ImageSrc}?mode=max&height=60`" :title="badge.Name" />
                </li>
              </ul>
            </template>
            <entrepreneurs-snippet :entrepreneurs="business.entrepreneurs" />
          </tile>
        </div>
      </div>
      <div v-else class="empty-list">
        <div class="magIcon" />
        <h2 class="o-snippet-list__items">{{ $t('list-no-result') }}</h2>
      </div>
      <pagination v-if="nbPages > 1" v-model="currentPage" :nbPages="nbPages" />
    </div>
  </div>
</template>

<script>
import Tile from '@/components/ui/tile'
import EntrepreneursSnippet from '@/components/ui/entrepreneurs-snippet.vue'
import Pagination from '@/components/ui/pagination'
import Store from '@/stores/store'

export default {
  components: {
    Tile,
    EntrepreneursSnippet,
    Pagination
  },
  props: {
    businesses: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      businessesPerPage: 9
    }
  },
  computed: {
    badges: function() {
      return Store.getters.badges
    },
    hasItems: function() {
      return this.businesses.length > 0
    },
    paginatedBusinesses: function() {
      const from = (this.currentPage - 1) * this.businessesPerPage
      const to = from + this.businessesPerPage
      return this.businesses.slice(from, to)
    },
    nbPages: function() {
      return Math.ceil(this.businesses.length / this.businessesPerPage)
    }
  },
  methods: {
    getImage: function(business) {
      if (business.image) {
        return business.image.medium
      }
      return ''
    },
    getColor: function(business) {
      switch (business.entreprise_category) {
        case 'arts-oeuvre':
        case 'arts-autres':
        case 'arts-prestation':
          return 'm-tile--primary'
        case 'alimentation-boissons':
        case 'alimentation-autres':
        case 'alimentation-aliments':
          return 'm-tile--color1'
        case 'produits-accessoires':
        case 'produits-vetement':
        case 'produits-decorations':
        case 'produits-divertissements':
        case 'produits-autres':
          return 'm-tile--color2'
        case 'services-soins':
        case 'services-divertissement-loisir':
        case 'services-entretien':
        case 'services-autres':
          return 'm-tile--color3'
        default:
          return ''
      }
    },
    getBusinessBadges: function(business) {
      const businessBadges = []
      this.badges.forEach(badge => {
        if (business.badge_ids.includes(badge.UmbracoId)) {
          businessBadges.push(badge)
        }
      })
      return businessBadges
    }
  },
  watch: {
    businesses() {
      this.currentPage = 1
    }
  }
}
</script>
